import type { ApiMethodBase } from '@process-advisor/process-miner/api/types';
import { setInfluenceAnalysisMinMaxTasks as setInfluenceAnalysisMinMaxTasksDiagram, getInfluenceAnalysisMinMaxTasks as getInfluenceAnalysisMinMaxTasksDiagram } from '@process-advisor/process-miner/processMiner/processMiner';
import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';

export type MinMaxProps = ApiMethodBase & {
    min: number;
    max: number;
};

export const setInfluenceAnalysisMinMaxTasks = ({
    min,
    max,
}: MinMaxProps) => {
    setInfluenceAnalysisMinMaxTasksDiagram({min, max});
    apiProvider.updateDiagramInfluencers();
};


export const getInfluenceAnalysisMinMaxTasks = (): MinMaxProps => getInfluenceAnalysisMinMaxTasksDiagram();
